/** @typedef {{ to: string, icon: string, label: string, exact?: boolean, isActive?: (pathname: string) => boolean }} AdminNavItemConfig */

/** @type {{ id: string, label: string, items: AdminNavItemConfig[] }[]} */
export const ADMIN_NAV_GROUPS = [
  {
    id: 'publish',
    label: 'انتشار',
    items: [
      { to: '/admin/post', exact: true, icon: 'plusSquare', label: 'پست تکی' },
      { to: '/admin/posts', exact: true, icon: 'layers', label: 'پست فله‌ای' },
    ],
  },
  {
    id: 'shop',
    label: 'فروشگاه',
    items: [
      {
        to: '/admin/members',
        icon: 'comment',
        label: 'اعضا',
        isActive: (pathname) => pathname === '/admin/members' || pathname.indexOf('/admin/members/') === 0,
      },
      {
        to: '/admin/category',
        icon: 'differentItems',
        label: 'دسته فروشگاه',
        isActive: (pathname) => pathname === '/admin/category' || pathname.indexOf('/admin/category/') === 0,
      },
      { to: '/admin/file-up', exact: true, icon: 'edit', label: 'فایل قیمت' },
      { to: '/admin/series', exact: true, icon: 'layers', label: 'سری محصولات' },
      { to: '/admin/trash', exact: true, icon: 'trash', label: 'زباله‌دان' },
    ],
  },
  {
    id: 'rates',
    label: 'نرخ',
    items: [
      { to: '/admin/coin-rate', exact: true, icon: 'cart', label: 'نرخ سایت' },
      { to: '/admin/coin-wrate', exact: true, icon: 'direct', label: 'نرخ ربات' },
      { to: '/admin/rate-robot', exact: true, icon: 'setting', label: 'ربات بله' },
    ],
  },
  {
    id: 'settings',
    label: 'تنظیمات',
    items: [
      { to: '/admin/dashboard', exact: true, icon: 'version', label: 'داشبورد نسخه' },
      { to: '/admin/site-info', exact: true, icon: 'setting', label: 'مشخصات سایت' },
      { to: '/admin/contact', exact: true, icon: 'rubika', label: 'تماس' },
      { to: '/admin/content-guide', exact: true, icon: 'edit', label: 'راهنما' },
      { to: '/admin/password', exact: true, icon: 'lockKeyhole', label: 'رمز عبور' },
    ],
  },
];

export const ADMIN_SECTION_HUB_PATH = {
  publish: '/admin/hub/publish',
  shop: '/admin/hub/shop',
  rates: '/admin/hub/rates',
  settings: '/admin/settings',
};

export function getAdminSectionHubPath(sectionId) {
  return ADMIN_SECTION_HUB_PATH[sectionId] || '/';
}

export function getAdminNavGroup(sectionId) {
  return ADMIN_NAV_GROUPS.find((group) => group.id === sectionId);
}

export function getAdminSectionIdForPath(pathname) {
  for (const group of ADMIN_NAV_GROUPS) {
    for (const item of group.items) {
      if (getAdminNavItemActive(pathname, item)) {
        return group.id;
      }
    }
  }

  return null;
}

export function getAdminNavItemActive(pathname, item) {
  if (typeof item.isActive === 'function') {
    return item.isActive(pathname);
  }

  if (item.exact) {
    return pathname === item.to;
  }

  return pathname === item.to || pathname.indexOf(item.to + '/') === 0;
}
